import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ml-prompt-field',
    templateUrl: './ml-prompt-field.component.html',
    styleUrls: ['./ml-prompt-field.component.css']
})
export class MlPromptFieldComponent implements OnInit {

    @Input() prompt!: string;
    @Input() placeholder!: string;

    @Output() promptChange = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {
    }

    onChange(event) {
        this.prompt = event;
        this.promptChange.emit(this.prompt);
    }
}
